import { API_ENDPOINT } from "../constants";
import { HTTP } from "./http";

export const ShortLinksService = {

    getLinks: (account_id) => {
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}accounts/contact-me/get-links/${account_id}`);
    },

    save: (account_id, message, app, trigger, label, sub_account_id, advanced_follow ) => {
        return HTTP.post<any, any>(`${API_ENDPOINT.CORE}accounts/contact-me/add-links`, { account_id, message, app, trigger, label, sub_account_id, advanced_follow } );
    },

    update: (account_id, message, token, app, advanced_follow, label, trigger, sub_account_id) => {
        return HTTP.put<any, any>(`${API_ENDPOINT.CORE}accounts/contact-me/edit-links`, { account_id, message, token, app, trigger, label, sub_account_id, advanced_follow } );
    },

    delete: (account_id, token) => {
        return HTTP.delete<any, any>(`${API_ENDPOINT.CORE}accounts/contact-me/delete-links`, { data: { account_id, token } });
    },
    getReportClicks:(account_id,token)=>{
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}accounts/contact-me/get-report-clicks/${account_id}/${token}`);
    },
    getReportsConversions:(account_id,token)=>{
        return HTTP.get<any, any>(`${API_ENDPOINT.CORE}accounts/contact-me/get-report-convertions/${account_id}/${token}`);
    }
}